import HealthIcon from '../images/icons/Health.svg';
import ConflictIcon from '../images/icons/Conflict.svg';
import PoliticalIcon from '../images/icons/Government-office.svg';
import OutbreakIcon from '../images/icons/Infection-control.svg';
import EbolaIcon from '../images/icons/Virus.svg';
import VaccinationIcon from '../images/icons/Vaccine.svg';
import MaternalCareIcon from '../images/icons/Pregnant.svg';
import DroneImpactIcon from '../images/icons/Airport.svg';

import FacilitiesIcon from '../images/icons/Health-facility.svg';
import WorkersIcon from '../images/icons/Health-worker.svg';
import { defaultTheme } from 'styles';

export const health = {
    filters: {
        categories: {
            health: 'Health',
            outbreak: 'Outbreak',
            ebola: 'Ebola',
            conflict: 'Conflict',
            political: 'Political',
            vaccination: 'Vaccination',
            maternalCare: 'MaternalCare',
            DroneImpact: 'DroneImpact',
        } as const,
        categoryOptions: [
            {
                value: 'Health',
                label: 'All categories',
                colour: defaultTheme.palette.colors.healthBlue,
                icon: HealthIcon,
            },
            {
                value: 'Conflict',
                label: 'Conflict',
                colour: defaultTheme.palette.colors.conflictRed,
                icon: ConflictIcon,
            },
            {
                value: 'Outbreak',
                label: 'Outbreak',
                colour: defaultTheme.palette.colors.outbreakGreen,
                icon: OutbreakIcon,
            },
            {
                value: 'Ebola',
                label: 'Ebola',
                colour: defaultTheme.palette.colors.ebolaRed,
                icon: EbolaIcon,
            },
            {
                value: 'Political',
                label: 'Political',
                colour: defaultTheme.palette.colors.politicalOrange,
                icon: PoliticalIcon,
            },
            {
                value: 'Vaccination',
                label: 'Vaccination',
                colour: defaultTheme.palette.colors.vaccinationGold,
                icon: VaccinationIcon,
            },
            {
                value: 'MaternalCare',
                label: 'Maternal Care',
                colour: defaultTheme.palette.colors.maternalPurple,
                icon: MaternalCareIcon,
            },
            {
                value: 'DroneImpact',
                label: 'Drone Impact',
                colour: defaultTheme.palette.colors.droneBrown,
                icon: DroneImpactIcon,
            },
        ],
        dates: {
            from: new Date('2016-01-01'),
            to: new Date(), // This is today
        },
    },
    reportIcons: {
        FacilitiesIcon,
        WorkersIcon,
    },
};
